import { render, staticRenderFns } from "./cancelRegistration.vue?vue&type=template&id=ea5a966a&scoped=true"
import script from "./cancelRegistration.vue?vue&type=script&lang=js"
export * from "./cancelRegistration.vue?vue&type=script&lang=js"
import style0 from "./cancelRegistration.vue?vue&type=style&index=0&id=ea5a966a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea5a966a",
  null
  
)

export default component.exports